const apikey = 'AIzaSyBf_zev-wYZfFPXOW7bygNJwYHAthecVwc';

function getStaticGoogleMapImage(lat, lang, markerImage) {
  if (!lat || !lang) return '';
  const googleMapLink = `https://maps.googleapis.com/maps/api/staticmap?center=${lat}%2C${lang}&size=512x250&zoom=14&markers=icon:${markerImage}|${lat}%2C${lang}&key=${apikey}`;

  return googleMapLink;
}
module.exports = { getStaticGoogleMapImage };
